module.exports = __webpack_public_path__ + "static/media/115.96b39077.jpg";